import React, { useContext } from 'react';
import styles from './PoliceS3.styles.js';
import { Input, Divider, Select } from 'antd'; // Importamos Input de Ant Design
import AppButton from 'Components/common/Forms/AppButton/AppButton.jsx';
import { AppContext } from 'App.context.js';
import Loading from 'Components/common/Loader/Loading.jsx';
import usePoliceReportS3ConfigHook from './PoliceS3.hook.js';
import { show2FAModal } from 'Components/common/TwoFactorModal/TwoFactorModal';

export default function PoliceS3({ type }) {
  const { state, actions } = usePoliceReportS3ConfigHook(type);
  const {
    appState,
    appActions: { translate },
  } = useContext(AppContext);

  return (
    <div>
      <div style={{ marginTop: '16px' }}>
        <b style={styles.confTitle}>{translate('policeReport.s3ConfigurationTitle')}</b>
      </div>

      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.ftpHost')}</b>
          <Input
            bordered={false}
            value={'transfer-family.civitfun.com'}
            disabled={true}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>
        <div style={styles.port}>
          <b style={styles.header}>{translate('policeReport.ftpPort')}</b>
          <Input
            bordered={false}
            value={'22'}
            disabled={true}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>
      </div>
      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.ftpFilePrefix')}</b>
          <Input
            bordered={false}
            value={state.filePrefix || ''}
            onChange={e => actions.setField('filePrefix', e.target.value)}
            disabled={state.isLoading}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>

        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.fileFormat')}</b>
          <Select
            defaultValue="YYYY-MM-DD"
            bordered={false}
            value={state.fileFormat || 'YYYY-MM-DD'}
            style={{ backgroundColor: '#f5f5f5', width: '100%' }}
            onChange={value => actions.setField('fileFormat', value)}
            options={[
              { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' },
              { value: 'YYYYMMDD', label: 'YYYYMMDD' },
              { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY' },
              { value: 'DDMMYYYY', label: 'DDMMYYYY' },
            ]}
            disabled={state.isLoading}
          />
        </div>

        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.ftpFileSufix')}</b>
          <Input
            bordered={false}
            value={state.fileSufix || ''}
            onChange={e => actions.setField('fileSufix', e.target.value)}
            disabled={state.isLoading}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>

        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.extension')}</b>
          <Select
            bordered={false}
            value={state.extension || 'txt'}
            style={{ backgroundColor: '#f5f5f5', width: '100%' }}
            onChange={value => actions.setField('extension', value)}
            options={[
              { value: '.txt', label: '.txt' },
              { value: '.TXT', label: '.TXT' },
              { value: '.xml', label: '.xml' },
              { value: '.XML', label: '.XML' },
            ]}
            disabled={state.isLoading}
          />
        </div>
      </div>

      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.completeFileName')}</b>
          <Input
            bordered={false}
            value={state.filePrefix + state.fileFormat + state.fileSufix + state.extension}
            disabled={true}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>
      </div>

      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.dateSelector.title')}</b>
          <div></div>
          <Select
            defaultValue="yesterday"
            bordered={false}
            value={state.dateSelected || 'yesterday'}
            style={{ backgroundColor: '#f5f5f5', width: '100%', minWidth: 200 }}
            onChange={value => actions.setField('dateSelected', value)}
            options={[
              { value: 'yesterday', label: translate('policeReport.dateSelector.yesterday') },
              { value: 'today', label: translate('policeReport.dateSelector.today') },
            ]}
            disabled={state.isLoading}
            dropdownRender={menu => (
              <div
                style={{
                  maxWidth: '100%',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  paddingRight: 8,
                  lineHeight: 1.4,
                }}
              >
                {menu}
              </div>
            )}
          />
        </div>
      </div>
      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.ftpDirPath')}</b>
          <Input
            bordered={false}
            value={state.s3DirPath || ''}
            onChange={e => actions.setField('s3DirPath', e.target.value)}
            disabled={true}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>
      </div>

      <div style={styles.credentialsContainer}>
        <div style={styles.inputContainer}>
          <b style={styles.header}>{translate('policeReport.testFile')}</b>
          <Input
            bordered={false}
            value={state.testFile || ''}
            onChange={e => actions.setField('testFile', e.target.value)}
            disabled={state.isLoading}
            style={{ backgroundColor: '#f5f5f5' }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            marginTop: '22px',
            marginBottom: '16px',
          }}
        >
          <AppButton
            text={translate('policeReport.validateFileExport')}
            secondary
            action={() => actions.validateFileExport()}
            disabled={state.isLoading}
          />
        </div>
      </div>

      {appState.superUser && type === 'RH' && (
        <div style={styles.credentialsContainer}>
          <div style={styles.inputContainer}>
            <div style={{ marginBottom: 10 }}>
              <b style={styles.header}>{translate('checkinConfig.civitfunAdminConfiguration')}:</b>
            </div>

            <b style={styles.header}>{translate('policeReport.defaultAltaStatusTitle')}</b>
            <Select
              defaultValue="fileStatus"
              bordered={false}
              value={state.sendStatusType || 'fileStatus'}
              style={{ backgroundColor: '#f5f5f5', width: '100%', minWidth: 200 }}
              onChange={value => actions.setField('sendStatusType', value)}
              options={[
                { value: 'allAlta', label: translate('policeReport.sendDefaultAltaStatus') },
                { value: 'fileStatus', label: translate('policeReport.getStatusFromFile') },
              ]}
              disabled={state.isLoading}
              dropdownRender={menu => (
                <div
                  style={{
                    maxWidth: '100%',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    paddingRight: 8,
                    lineHeight: 1.4,
                  }}
                >
                  {menu}
                </div>
              )}
            />
          </div>
        </div>
      )}

      <div style={styles.buttonContainer}>
        {state.isLoading && <Loading size={'small'} />}
        <AppButton
          text={translate('policeReport.checkConnection')}
          secondary
          action={() => actions.onCheckConnection()}
          disabled={state.isLoading}
        />

        <AppButton
          text={translate('policeReport.save')}
          action={async () => {
            const twoFAResult = await show2FAModal();

            if (twoFAResult === true) {
              actions.onSaveFTPConfig();
            }
          }}
          disabled={state.isLoading}
        />
      </div>

      {state.ftpErrors.length === 0 && state.isValidation && (
        <div>
          <Divider style={{ borderColor: '#009ae9' }}>
            {translate('policeReport.ftpResult')}
          </Divider>
          <div style={styles.validateSFTPWithoutErrors}>
            {translate('policeReport.validateSFTPWithoutErrors')}
          </div>
        </div>
      )}
      {state?.ftpfileValidationError && (
        <div>
          <Divider style={{ borderColor: '#009ae9' }}>
            {translate('policeReport.ftpResult')}
          </Divider>
          <div style={styles.validateSFTPWithErrors}>{state.ftpfileValidationError}</div>
        </div>
      )}

      {state?.ftpErrors?.length > 0 && state.isValidation && (
        <div>
          <Divider style={{ borderColor: '#009ae9' }}>{translate('policeReport.ftpFiles')}</Divider>
          <div style={styles.credentialsContainer}>
            <ul>
              {state.ftpErrors.map((file, index) => (
                <li
                  key={index}
                  style={file.error === 'error' ? { color: 'red', fontWeight: 'bold' } : {}}
                >
                  {file.message}
                </li>
              ))}
              <br />
              <span
                dangerouslySetInnerHTML={{
                  __html: translate('policeReport.explainRedColorFileValidation').replace(
                    /\{(.*?)\}/g,
                    '<span style="color: red; font-weight: bold;">$1</span>'
                  ),
                }}
              />
            </ul>
          </div>
        </div>
      )}

      {!!state?.ftpFiles && state?.isFileList && (
        <div>
          <Divider style={{ borderColor: '#009ae9' }}>{translate('policeReport.ftpFiles')}</Divider>
          <div style={styles.credentialsContainer}>
            {state?.ftpFiles?.length > 0 ? (
              <ul>
                {state.ftpFiles.map((file, index) => (
                  <li key={index}>{file}</li>
                ))}
              </ul>
            ) : (
              <>{translate('policeReport.noFilesFound')}</>
            )}
          </div>
        </div>
      )}
      {state.fileContent && state.fileContent.length > 0 && (
        <div>
          <Divider style={{ borderColor: '#009ae9' }}>
            {translate('policeReport.ftpFileContent')}
          </Divider>
          <div style={styles.credentialsContainer}>{state.fileContent}</div>
        </div>
      )}
    </div>
  );
}
